import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      minimiseInterestPaid: boolean(Joi).label(
        labeled(label, 'Minimise interest paid over life of loan')
      ),
      higherLendingLimit: boolean(Joi).label(labeled(label, 'Higher lending limit')),
      lowerDepositRequired: boolean(Joi).label(labeled(label, 'Lower deposit required')),
      buildUpEquity: boolean(Joi).label(labeled(label, 'Build up equity from the start')),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue(
      'minimiseInterestPaid',
      'higherLendingLimit',
      'lowerDepositRequired',
      'buildUpEquity',
      'other'
    )
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
